import Color from 'color';
var Colors = {
    azure: new Color('#f0ffff'),
    beige: new Color('#f5f5dc'),
    black: new Color('#000000'),
    blue: new Color('#0000ff'),
    brown: new Color('#a52a2a'),
    cyan: new Color('#00ffff'),
    darkblue: new Color('#00008b'),
    darkcyan: new Color('#008b8b'),
    darkgrey: new Color('#a9a9a9'),
    darkgreen: new Color('#006400'),
    darkkhaki: new Color('#bdb76b'),
    darkmagenta: new Color('#8b008b'),
    darkolivegreen: new Color('#556b2f'),
    darkorange: new Color('#ff8c00'),
    darkorchid: new Color('#9932cc'),
    darkred: new Color('#8b0000'),
    darksalmon: new Color('#e9967a'),
    darkviolet: new Color('#9400d3'),
    fuchsia: new Color('#ff00ff'),
    gold: new Color('#ffd700'),
    green: new Color('#008000'),
    indigo: new Color('#4b0082'),
    khaki: new Color('#f0e68c'),
    lightblue: new Color('#add8e6'),
    lightcyan: new Color('#e0ffff'),
    lightgreen: new Color('#90ee90'),
    lightgrey: new Color('#d3d3d3'),
    lightpink: new Color('#ffb6c1'),
    lightyellow: new Color('#ffffe0'),
    lime: new Color('#00ff00'),
    magenta: new Color('#ff00ff'),
    maroon: new Color('#800000'),
    navy: new Color('#000080'),
    olive: new Color('#808000'),
    orange: new Color('#ffa500'),
    pink: new Color('#ffc0cb'),
    purple: new Color('#800080'),
    violet: new Color('#800080'),
    red: new Color('#ff0000'),
    silver: new Color('#c0c0c0'),
    white: new Color('#ffffff'),
    yellow: new Color('#ffff00'),
    softgreen: new Color('#bbedc3'),
    softyellow: new Color('#ffe88b'),
    softred: new Color('#fdb9c3'),
};
export default Colors;
/**
 *
 * @return {*}
 */
export function getHexArray() {
    var names = Object.keys(Colors);
    return names.map(function (name) {
        return Colors[name].hex();
    });
}
/**
 *
 * @return {string}
 */
export function getRandomColor() {
    var names = Object.keys(Colors);
    var index = Math.floor(names.length * Math.random());
    return Colors[names[index]];
}
